import './control.css';
import './controlMobile.css';
import React, { useEffect, useState, useMemo } from 'react';
import User from '../User/user';
import { useCookies } from "react-cookie";
import { RiSettings4Line } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { turnOffAC } from '../../Services/control/turnOffAC';
import { turnOnAC } from '../../Services/control/turnOnAC';
import { turnOffLight } from '../../Services/control/turnOffLight';
import { turnOnLight } from '../../Services/control/turnOnLight';
import { getMessageBroadcast } from '../../Services/read/getMessageBroadcast';
import TempGraph from '../../Components/Graphs/tempGraph';
import HumiGraph from '../../Components/Graphs/humiGraph';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MessageInfo from '../../Components/MessageBroadcast/messageInfo';
import { getAllData } from '../../Services/read/getAllData';
import { broadcastMessageNow } from '../../Services/control/broadcastMessageNow';
import { getAllDataHistory } from '../../Services/read/getAllDataHistory';
import { useMediaQuery } from 'react-responsive';
import { useWindowDimensions } from '../../Utilities/windowDimension';
import { MenuItem } from '@mui/material';
import AutomaticState from '../../Components/State/automatic';
import { getAutomaticModeData } from '../../Services/read/getAutomaticModeData';
import { printMessage } from '../../Services/control/printMessage';
import Toggle from '../../Components/Buttons/toggle';
import { Formik } from 'formik';
import Spinner from '../../Spinner';



const Control = () => {
  let navigate = useNavigate();
  const isMobile = useMediaQuery({ query: '(max-width: 1200px)' });
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [acState, setAcState] = useState('unknown');
  const [lightState, setLightState] = useState('unknown');
  const [refresh, setRefresh] = useState(0);
  const [allData, setAllData] = useState([]);
  const [insideTemp, setInsideTemp] = useState('');
  const [insideHumi, setInsideHumi] = useState('');
  const [outsideTemp, setOutsideTemp] = useState('');
  const [outsideHumi, setOutsideHumi] = useState('');
  const [insideTemp2, setInsideTemp2] = useState('');
  const [insideHumi2, setInsideHumi2] = useState('');
  const [insideCheck, setInsideCheck] = useState(true);
  const [outsideCheck, setOutsideCheck] = useState(true);
  const [nbJours, setNbJours] = useState(2);
  const [actualMin, setactualMin] = useState(0);
  const [actualMax, setactualMax] = useState(0);
  const [isAutoOn, setIsAutoOn] = useState(false);
  const [broadcastEnable, setBroadcastEnable] = useState(false);
  const [broadcastTime, setBroadcastTime] = useState(3);
  const [broadcastMessage, setBroadcastMessage] = useState("");
  const [message1, setMessage1] = useState('');
  const [message2, setMessage2] = useState('');
  

  const graphData = useMemo(() => {
    const timeLabels = [];
    const insideTemp = [];
    const insideHumi = [];
    const outsideTemp = [];
    const outsideHumi = [];
    const insideTemp2 = [];
    const insideHumi2 = [];
    const acstate = [];

    for (let k = 0; k < allData.length; k++) {
      timeLabels.push(new Date(allData[k].createdAt).toLocaleTimeString("en-GB").slice(0, -3));
      !allData[k].InsideTemp ? insideTemp.push(NaN) : insideTemp.push(allData[k].InsideTemp);
      !allData[k].InsideHumi ? insideHumi.push(NaN) : insideHumi.push(allData[k].InsideHumi);
      !allData[k].InsideTemp2 ? insideTemp2.push(NaN) : insideTemp2.push(allData[k].InsideTemp2);
      !allData[k].InsideHumi2 ? insideHumi2.push(NaN) : insideHumi2.push(allData[k].InsideHumi2);
      !allData[k].OutsideTemp ? outsideTemp.push(NaN) : outsideTemp.push(allData[k].OutsideTemp);
      !allData[k].OutsideHumi ? outsideHumi.push(NaN) : outsideHumi.push(allData[k].OutsideHumi);
      allData[k].acstate === 'ON' ? acstate.push(27) : acstate.push(NaN);
    }

    const result = {
      timeLabels: timeLabels,
      insideTemp: insideTemp,
      insideHumi: insideHumi,
      insideTemp2: insideTemp2,
      insideHumi2: insideHumi2,
      outsideTemp: outsideTemp,
      outsideHumi: outsideHumi,
      acstate: acstate
    }

    return result;
  }, [allData])

  const handleInsideCheckChange = () => {
    setInsideCheck(!insideCheck);
  }

  const handleOutsideCheckChange = () => {
    setOutsideCheck(!outsideCheck);
  }

  const handleNbJoursChange = (event) => {
    setNbJours(event.target.value);
  };

  useEffect(() => {
    async function fetchData() {
      setCookie('accessToken', cookies.accessToken);
      const allData = await getAllData();
      if (allData.data) {
        setInsideTemp(allData.data.insideTemp);
        setInsideHumi(allData.data.insideHumi);
        setOutsideTemp(allData.data.outsideTemp);
        setOutsideHumi(allData.data.outsideHumi);
        setInsideTemp2(allData.data.insideTemp2);
        setInsideHumi2(allData.data.insideHumi2);
        setAcState(allData.data.acstate);
        setLightState(allData.data.lightstate);
      } else {
        console.log('problem fetching data');
      }
      const allDataHistory = await getAllDataHistory({numberOfDays: nbJours});
      if (allDataHistory.data) {
        setAllData(allDataHistory.data);
      } else {
        console.log('problem fetching data');
      }
      const autoInfo = await getAutomaticModeData();
      if (autoInfo) {
        setIsAutoOn(autoInfo.data.automaticMode)
        setactualMin(autoInfo.data.lowerThreshold)
        setactualMax(autoInfo.data.upperThreshold)
      } else {
        console.log('No info about Automatic Mode found 😞');
      }
      const broadcastInfo = await getMessageBroadcast();
      if (broadcastInfo) {
        setBroadcastEnable(broadcastInfo.data.broadcastEnable)
        setBroadcastTime(broadcastInfo.data.broadcastTime)
        setBroadcastMessage(broadcastInfo.data.message)
      } else {
        console.log('No info about Broadcast message found 😞');
      }
    }
    fetchData();
  }, [nbJours, refresh]);

  const triggerAC = async () => {
    if (acState === 'OFF') {
      await turnOnAC(cookies.accessToken);
      setRefresh(refresh + 1);
    } else {
      await turnOffAC(cookies.accessToken);
      setRefresh(refresh + 1);
    }
  }

  const triggerOutsideLight = async () => {
    if (lightState === 'OFF') {
      await turnOnLight(cookies.accessToken);
      setRefresh(refresh + 1);
    } else {
      await turnOffLight(cookies.accessToken);
      setRefresh(refresh + 1);
    }
  }

  const handleSendingMessage = async (credentials, setSubmitting) => {
    setMessage1('');
    try {
      const result = await broadcastMessageNow(credentials, cookies.accessToken);
      if (result.data) {
        setMessage1('Message is being broadcasted!')
      }
      setSubmitting(false);
    } catch (error) {
      if (error.message) {
        setMessage1(error.message);
      }
      console.log(error);
      setSubmitting(false);
    }
  }

  const handlePrintingMessage = async (credentials, setSubmitting) => {
    setMessage2('');
    try {
      const result = await printMessage(credentials, cookies.accessToken);
      if (result.data) {
        setMessage2('Message is being printed!')
      }
      setSubmitting(false);
    } catch (error) {
      if (error.message) {
        setMessage2(error.message);
      }
      console.log(error);
      setSubmitting(false);
    }
  }

  return (
    <div>
      {isMobile &&
        <div className='ControlPage'>
          <div className='LeftControl'>
            <div className='Ac'>
              <div className='MobileControl'>
                <Toggle
                  name={'A/C'}
                  state={acState}
                  trigger={triggerAC}
                />
                <Toggle
                  name={'Light'}
                  state={lightState}
                  trigger={triggerOutsideLight}
                />
                <div className='Formik'>
                  <Formik
                    initialValues={{ messageToSend: '' }}
                    validate={values => {
                      const errors = {};
                      if (!values.messageToSend) {
                        errors.messageToSend = 'Required';
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      handlePrintingMessage({message: values.messageToSend.toLowerCase()}, setSubmitting)
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit} className='MessageToSendNowForm'>
                        {isSubmitting && 
                          <div className='Loading'>
                            <Spinner/>
                          </div>
                        }
                        {!isSubmitting && 
                          <>
                            <div className='MessageToSendNowInput'>
                              <label
                                className='label'
                              >
                                Print a message
                              </label>
                              <input
                                type="text"
                                name="messageToSend"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.messageToSend}
                                className='messageToSend'
                              />
                              <h6>
                                {message2 || ' '}
                              </h6>
                            </div>
                            <button type="submit" disabled={isSubmitting} className='SubmitMessageToSendNow'>
                              Print
                            </button>
                          </>
                        }
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
              <div style={{height: 32}} />
              <div className='WeatherBoxTemp'>
                <div className='TopWeatherBox'>
                  Température Actuelle
                </div>
                <div className='BottomWeatherBox'>
                  <div className='LeftWeatherBox'>
                    <div>
                      Intérieur
                    </div>
                    <div>
                      {insideTemp}°C
                    </div>
                  </div>
                  <div className='RightWeatherBox'>
                    <div>
                      Extérieur
                    </div>
                    <div>
                      {outsideTemp}°C
                    </div>
                  </div>
                </div>
              </div>
              <div className='WeatherBoxHumi'>
                <div className='TopWeatherBox'>
                  Humidité Actuelle
                </div>
                <div className='BottomWeatherBox'>
                  <div className='LeftWeatherBox'>
                    <div>
                      Intérieur
                    </div>
                    <div>
                      {insideHumi}%
                    </div>
                  </div>
                  <div className='RightWeatherBox'>
                    <div>
                      Extérieur
                    </div>
                    <div>
                      {outsideHumi}%
                    </div>
                  </div>
                </div>
                <div className='Formik' style={{marginTop: 32}}>
                  <Formik
                    initialValues={{ messageToSend: '' }}
                    validate={values => {
                      const errors = {};
                      if (!values.messageToSend) {
                        errors.messageToSend = 'Required';
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      handleSendingMessage({message: values.messageToSend.toLowerCase()}, setSubmitting)
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit} className='MessageToSendNowForm'>
                        {isSubmitting && 
                          <div className='Loading'>
                            <Spinner/>
                          </div>
                        }
                        {!isSubmitting && 
                          <>
                            <div className='MessageToSendNowInput'>
                              <label
                                className='label'
                              >
                                Broadcast a message NOW
                              </label>
                              <input
                                type="text"
                                name="messageToSend"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.messageToSend}
                                className='messageToSend'
                              />
                              <h6>
                                {message1 || ' '}
                              </h6>
                            </div>
                            <button type="submit" disabled={isSubmitting} className='SubmitMessageToSendNow'>
                              Broadcast message
                            </button>
                          </>
                        }
                      </form>
                    )}
                  </Formik>
                </div>
                <User/>
              </div>
            </div>
          </div>
          <div className='RightControl'>
            <div className='LoggedInTempHumi'>
              <div className='OptionSelect'>
                <div className='DateSelect'>
                  Données des 
                    <FormControl variant='standard' sx={{ m: 1, maxWidth: 50}}>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={nbJours}
                        onChange={handleNbJoursChange}
                      >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={6}>6</MenuItem>
                        <MenuItem value={7}>7</MenuItem>
                      </Select>
                    </FormControl>
                  derniers jour(s)
                </div>
                <div className='ButtonSelect'>
                  Intérieur
                  <FormControlLabel control={<Checkbox checked={insideCheck} onChange={handleInsideCheckChange} sx={{color: '#004638', '&.Mui-checked': {color: '#004638'}}} size='large' />} />
                  Extérieur
                  <FormControlLabel control={<Checkbox checked={outsideCheck} onChange={handleOutsideCheckChange} sx={{color: '#82bf00', '&.Mui-checked': {color: '#82bf00'}}} size='large'/>} />
                </div>
              </div>
              <TempGraph 
                insideTemp={insideCheck ? graphData.insideTemp : []}
                insideTemp2={insideCheck ? graphData.insideTemp2 : []}
                acstate={insideCheck ? graphData.acstate : []}
                outsideTemp={outsideCheck ? graphData.outsideTemp : []}
                timelabels={graphData.timeLabels}
              />
              <HumiGraph 
                insideHumi={insideCheck ? graphData.insideHumi : []}
                insideHumi2={insideCheck ? graphData.insideHumi2 : []}
                acstate={insideCheck ? graphData.acstate : []}
                outsideHumi={outsideCheck ? graphData.outsideHumi : []}
                timelabels={graphData.timeLabels}
              />
              <div style={{height: 32}}/>
            </div>
          </div>
        </div>
      }
      {!isMobile &&
        <div className='ControlPage'>
          <div className='LeftControl'>
            <div className='LoggedInTempHumi'>
              <div className='OptionSelect'>
                <div className='DateSelect'>
                  Données des 
                    <FormControl variant='standard' sx={{ m: 1, maxWidth: 50}}>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={nbJours}
                        onChange={handleNbJoursChange}
                      >
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={6}>6</MenuItem>
                        <MenuItem value={7}>7</MenuItem>
                      </Select>
                    </FormControl>
                  derniers jour(s)
                </div>
                <div className='ButtonSelect'>
                  Intérieur
                  <FormControlLabel control={<Checkbox checked={insideCheck} onChange={handleInsideCheckChange} sx={{color: '#004638', '&.Mui-checked': {color: '#004638'}}} size='large' />} />
                  Extérieur
                  <FormControlLabel control={<Checkbox checked={outsideCheck} onChange={handleOutsideCheckChange} sx={{color: '#82bf00', '&.Mui-checked': {color: '#82bf00'}}} size='large'/>} />
                </div>
              </div>
              <TempGraph 
                insideTemp={insideCheck ? graphData.insideTemp : []}
                insideTemp2={insideCheck ? graphData.insideTemp2 : []}
                acstate={insideCheck ? graphData.acstate : []}
                outsideTemp={outsideCheck ? graphData.outsideTemp : []}
                timelabels={graphData.timeLabels}
              />
              <HumiGraph 
                insideHumi={insideCheck ? graphData.insideHumi : []}
                insideHumi2={insideCheck ? graphData.insideHumi2 : []}
                outsideHumi={outsideCheck ? graphData.outsideHumi : []}
                acstate={insideCheck ? graphData.acstate : []}
                timelabels={graphData.timeLabels}
              />
            </div>
          </div>
          <div className='RightControl'>
            <div className='Ac'>
              <div className='LightAndUser'>
                <div style={{width: 'fit-content', marginRight: 16}}>
                  <AutomaticState
                    automaticMode={isAutoOn}
                    lowerThreshold={actualMin}
                    upperThreshold={actualMax}
                  />
                </div>
                <button
                  className='UserPageButton'
                  onClick={() => navigate('/user')}
                >
                  <RiSettings4Line />
                </button>
              </div>
              <div className='Formik'>
                <Formik
                  initialValues={{ messageToSend: '' }}
                  validate={values => {
                    const errors = {};
                    if (!values.messageToSend) {
                      errors.messageToSend = 'Required';
                    }
                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    handlePrintingMessage({message: values.messageToSend.toLowerCase()}, setSubmitting)
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit} className='MessageToSendNowForm'>
                      {isSubmitting && 
                        <div className='Loading'>
                          <Spinner/>
                        </div>
                      }
                      {!isSubmitting && 
                        <>
                          <div className='MessageToSendNowInput'>
                            <label
                              className='label'
                            >
                              Print a message
                            </label>
                            <input
                              type="text"
                              name="messageToSend"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.messageToSend}
                              className='messageToSend'
                            />
                            <h6>
                              {message2 || ' '}
                            </h6>
                          </div>
                          <button type="submit" disabled={isSubmitting} className='SubmitMessageToSendNow'>
                            Print
                          </button>
                        </>
                      }
                    </form>
                  )}
                </Formik>
              </div>
              <div style={{display: 'flex'}}>
                <Toggle
                  name={'A/C'}
                  state={acState}
                  trigger={triggerAC}
                />
                <div style={{width: 16}} />
                <Toggle
                  name={'Light'}
                  state={lightState}
                  trigger={triggerOutsideLight}
                />
              </div>
              <div className='Formik'>
                <Formik
                  initialValues={{ messageToSend: '' }}
                  validate={values => {
                    const errors = {};
                    if (!values.messageToSend) {
                      errors.messageToSend = 'Required';
                    }
                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    handleSendingMessage({message: values.messageToSend.toLowerCase()}, setSubmitting)
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form onSubmit={handleSubmit} className='MessageToSendNowForm'>
                      {isSubmitting && 
                        <div className='Loading'>
                          <Spinner/>
                        </div>
                      }
                      {!isSubmitting && 
                        <>
                          <div className='MessageToSendNowInput'>
                            <label
                              className='label'
                            >
                              Broadcast a message NOW
                            </label>
                            <input
                              type="text"
                              name="messageToSend"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.messageToSend}
                              className='messageToSend'
                            />
                            <h6>
                              {message1 || ' '}
                            </h6>
                          </div>
                          <button type="submit" disabled={isSubmitting} className='SubmitMessageToSendNow'>
                            Broadcast message
                          </button>
                        </>
                      }
                    </form>
                  )}
                </Formik>
              </div>
              <div className='WeatherBoxTemp'>
                <div className='TopWeatherBox'>
                  Température Actuelle
                </div>
                <div className='BottomWeatherBox'>
                  <div className='LeftWeatherBox'>
                    <div>
                      Intérieur
                    </div>
                    <div>
                      {insideTemp}°C
                    </div>
                  </div>
                  <div className='RightWeatherBox'>
                    <div>
                      Extérieur
                    </div>
                    <div>
                      {outsideTemp}°C
                    </div>
                  </div>
                </div>
              </div>
              <div className='WeatherBoxHumi'>
                <div className='TopWeatherBox'>
                  Humidité Actuelle
                </div>
                <div className='BottomWeatherBox'>
                  <div className='LeftWeatherBox'>
                    <div>
                      Intérieur
                    </div>
                    <div>
                      {insideHumi}%
                    </div>
                  </div>
                  <div className='RightWeatherBox'>
                    <div>
                      Extérieur
                    </div>
                    <div>
                      {outsideHumi}%
                    </div>
                  </div>
                </div>
              </div>
              <div style={{marginTop: 5}}>
               <MessageInfo
                  broadcastEnable={broadcastEnable}
                  broadcastTime={broadcastTime}
                  message={broadcastMessage}
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Control;
